export default function updateLoggedInUserReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_LOGGED_IN_USER_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_LOGGED_IN_USER_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_LOGGED_IN_USER_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}